import React from "react";
import { useWindow } from "@fluentui/react/lib/WindowProvider";
import getDrawerPaneId from "owa-app-pane-group-utils/lib/getDrawerPaneId";
import { clearDrawerPaneAnchorMutator, drawerPaneAnchorChangedMutator, useDrawerPaneAnchor, } from "owa-drawer";
import { appModuleContainer, moduleContainer, addinDrawerAnchor, } from "./AddinsUnderRibbonContainer.scss";

export interface AddinsUnderRibbonContainerProps {
    enabled: boolean;
    children: React.ReactNode;
}

export const AddinsUnderRibbonContainer: React.FunctionComponent<AddinsUnderRibbonContainerProps> = function AddinsUnderRibbonContainer({ enabled, children }) {
    const targetWindow = useWindow() ?? window;
    const addinsDrawerPaneId = getDrawerPaneId("addins");
    const { orderStyle } = useDrawerPaneAnchor(addinsDrawerPaneId);
    
    // Register the anchor from a callback ref rather than a layout effect: the ref runs
    // during commit (before paint, same timing as useLayoutEffect) on DOM attach/detach,
    // which keeps the mutator calls out of the effect hooks that the
    // forbid-react-set-state-and-mutators-inside-specific-hooks rule guards. React re-runs
    // it (detach then attach) when targetWindow or the pane id changes.
    const registerAnchor = React.useCallback((node: HTMLDivElement | null) => {
        if (node) {
            drawerPaneAnchorChangedMutator(node, "mail", targetWindow, addinsDrawerPaneId);
        }
        else {
            clearDrawerPaneAnchorMutator(targetWindow, addinsDrawerPaneId);
        }
    }, [targetWindow, addinsDrawerPaneId]);
    
    if (!enabled) {
        return <>{children}</>;
    }
    
    return (<div className={appModuleContainer}>
                <div className={moduleContainer}>{children}</div>
                <div ref={registerAnchor} className={addinDrawerAnchor} style={orderStyle}/>
            </div>);
};
